import { z } from "zod";
export const UsageKindSchema = z.enum(["interval", "channel_change", "channel3_visit", "guide_open", "ad_eligible", "ad_preview", "ad_requested", "ad_filled", "ad_unfilled", "ad_blocked", "ad_error"]);
export const UsageEventSchema = z.object({
    id: z.string().uuid(),
    kind: UsageKindSchema,
    visible_ms: z.number().int().min(0).max(30_000).default(0),
    playback_ms: z.number().int().min(0).max(30_000).default(0),
    guide_ms: z.number().int().min(0).max(30_000).default(0),
    placement: z.enum(["guide", "cabinet"]).optional()
}).strict().superRefine((event, context) => {
    if (event.playback_ms > event.visible_ms || event.guide_ms > event.visible_ms || event.playback_ms + event.guide_ms > event.visible_ms)
        context.addIssue({ code: "custom", message: "Duration exceeds visible time" });
    if (event.kind !== "interval" && (event.visible_ms || event.playback_ms || event.guide_ms))
        context.addIssue({ code: "custom", message: "Only intervals carry duration" });
    if (event.kind.startsWith("ad_") !== Boolean(event.placement))
        context.addIssue({ code: "custom", message: "Placement required only for ad diagnostics" });
});
export const UsageBatchSchema = z.object({ session_id: z.string().uuid(), events: z.array(UsageEventSchema).min(1).max(20) }).strict();
